export default "__VITE_ASSET__5407b0dd__"